export default __webpack_public_path__ + "static/media/minus.00c625a2.svg";